import * as Actions from '../../actions/pdf/type';

export const uploadPdfAndSendEmail = (state = {}, action) => {
  switch (action.type) {
    case Actions.UPLOAD_PDF_AND_SEND_EMAIL_REQUEST:
      return { loading: true };
    case Actions.UPLOAD_PDF_AND_SEND_EMAIL_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
      };
    case Actions.UPLOAD_PDF_AND_SEND_EMAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // case Actions.CLEAR_PAYMENT_STATE:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: '',
    //   };
    default:
      return state;
  }
};
